import { render } from "./BaseMain.vue?vue&type=template&id=23b0022e&scoped=true"
import script from "./BaseMain.vue?vue&type=script&lang=js"
export * from "./BaseMain.vue?vue&type=script&lang=js"

import "./BaseMain.vue?vue&type=style&index=0&id=23b0022e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b0022e"]])

export default __exports__